import { render, staticRenderFns } from "./PulseQuestions.vue?vue&type=template&id=4cb59201&scoped=true"
import script from "./PulseQuestions.vue?vue&type=script&lang=ts"
export * from "./PulseQuestions.vue?vue&type=script&lang=ts"
import style0 from "./PulseQuestions.vue?vue&type=style&index=0&id=4cb59201&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb59201",
  null
  
)

export default component.exports